import { CustomHomepageGrid, HomePageCompanyLogo, HomePageStarredEntities } from '@backstage/plugin-home';
import { Grid } from '@material-ui/core';
import Logo from '../Root/Logo';
import { Content, ContentHeader, Page, SupportButton } from '@backstage/core-components';
import { defaultConfig } from './defaultConfig';
import { Welcome } from './Welcome';
import {
  HomepagePavedPathsCard,
  HomepageAddYourServiceCard,
  HomepageInternalToolsCard,
  HomepageGetHelpCard,
} from './plugins';
import { tools } from './rdcTools';
import PavePathsOnboardingChecklist from './PavedPathsOnboardingChecklist';
import { JiraUserIssuesViewCard } from '@axis-backstage/plugin-jira-dashboard';
import { HomePageSearchBar } from '@backstage/plugin-search';

export const HomePage = () => {
  return (
    <Page themeId="home">
      <Content>
        <ContentHeader title="">
          <SupportButton>Support & Feedback</SupportButton>
        </ContentHeader>
        <Grid container>
          <Grid justifyContent="center" container>
            <HomePageCompanyLogo logo={<Logo height={100} fill="#000000" />} />
          </Grid>
          <Grid item xs={12}>
            <Welcome />
          </Grid>
          <Grid item xs={12}>
            <PavePathsOnboardingChecklist />
          </Grid>
          <Grid item xs={12}>
            <CustomHomepageGrid config={defaultConfig}>
              <HomePageSearchBar />
              <HomePageStarredEntities title="Your Favorites" />
              <HomepageAddYourServiceCard />
              <HomepagePavedPathsCard title="Paved Paths" />
              <JiraUserIssuesViewCard title="Assigned Jira Issues" maxResults={25} />
              <HomepageGetHelpCard />
              <HomepageInternalToolsCard tools={tools} />
            </CustomHomepageGrid>
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};
